import styled from "styled-components"
import background from './mountain.jpg'

export const LoginBackground = styled.div`
  position: absolute;
  width: 100%;
  height: auto;
  min-height: 100vh;
  min-width:380px;
  background: linear-gradient(0deg, rgba(0,0,0,0.8), rgba(0,0,0,0.8)),  url(${background}) repeat;
  content: "";
  z-index: -1;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
  background-size: 100% 100%;
  background-position: center center;
  background-repeat: no-repeat;
  background-attachment: fixed;

  @media screen and (max-width:380px){
    background: none;
  }
`

export const SubmitButton = styled.button`
  cursor: pointer;
  display: block;
  text-align: center;
  font-size: 1em;
  margin-bottom: .75em;
  margin-top: .5em;
  text-decoration: none;
  color: ${({ theme }) => theme.colors.altButtonText};
  border-radius: 5px;
  border: none;
  width:100px;
  height:30px;
  z-index: 1;

  background: linear-gradient(to left, ${({ theme }) => theme.colors.altButtonInitial} 50%, ${({ theme }) => theme.colors.altButtonHover} 50%);
  background-size: 200% 100%;
  background-position: right bottom;
  transition: all 0.5s ease;

  &:hover{
    background-position: left bottom;
    color:${({ theme }) => theme.colors.altButtonTextHover};
    font-weight: bold;
  }

  &.loading{
    opacity: .8;
    background: ${({ theme }) => theme.colors.altButtonLoading};
  }

  &.marginTop{
    margin-top:1em;
  }
  
  &.marginBottom{
    margin-bottom:1em;
  }

  &.marginRight{
    margin-right:1em;
  }

  &.marginLeft{
    margin-left:1em;
  }

  @media screen and (max-width:768px){
    -ms-transform: scale(.85);
    -webkit-transform: scale(.85); 
    transform: scale(.85);
    margin-top: .25em;
  }

  @media screen and (max-width:380px){
    -ms-transform: scale(.75);
    -webkit-transform: scale(.75); 
    transform: scale(.75);
  }
`

export const InputBox = styled.input`
  background: none;
  
  display:table-cell;
  margin: 0 auto;
  color: ${({ theme }) => theme.colors.textColor};
  margin-top: 1em;
  font-size: 1.3em;
  border:0;
  width: 15em;
  height: 2.5em;
  padding-left: .25em;
  border-radius: 2px;
  border: 1px solid ${({ theme }) => theme.colors.inputBorder};
  outline:0;
  ::-webkit-input-placeholder {color: ${({ theme }) => theme.colors.textColor};}  
  :-moz-placeholder {color: ${({ theme }) => theme.colors.textColor};} 
  ::-moz-placeholder {color: ${({ theme }) => theme.colors.textColor};} 
  :-ms-input-placeholder {color: ${({ theme }) => theme.colors.textColor};} 
  ::placeholder {color: ${({ theme }) => theme.colors.textColor};} 

  &:focus::-webkit-input-placeholder { opacity: 0; } 
  &:focus:-moz-placeholder { opacity: 0; } 
  &:focus::-moz-placeholder { opacity: 0; }
  &:focus:-ms-input-placeholder { opacity: 0; }
  &:focus::placeholder { opacity: 0}; 

  &:focus{
    background-color: ${({ theme }) => theme.colors.inputFocus};
  }

  &.noTopMargin{
    margin-top:0px;
  }

  @media screen and (max-width:768px){
    width: 10em;
    height: 1.5em;
    font-size: 1.2em;
    margin-top: .75em;
  }

  @media screen and (max-width:380px){
    width: 8em;
    height: 1.5em;
    font-size: 1em;
    margin-top: .5em;
  }

  :-webkit-autofill,
  :-webkit-autofill:hover, 
  :-webkit-autofill:focus, 
  :-webkit-autofill:active{
    -webkit-box-shadow: 0 0 0 30px ${({ theme }) => theme.colors.background} inset !important;
  }

  :-webkit-autofill{
    -webkit-text-fill-color: ${({ theme }) => theme.colors.textColor} !important;
  }
`
export const AuthBox = styled.input`
  background:none;
  display:table-cell;
  margin: 0 auto;
  color: ${({ theme }) => theme.colors.textColor};
  margin-top: .5em;
  font-size: 1.25em;
  border:0;
  width: 10em;
  height: 2.5em;
  padding-left: .25em;
  border-radius: 2px;
  border: 1px solid ${({ theme }) => theme.colors.inputBorder};
  outline:0;
  margin-bottom: .5em;
  ::-webkit-input-placeholder {color: ${({ theme }) => theme.colors.textColor};}  
  :-moz-placeholder {color: ${({ theme }) => theme.colors.textColor};} 
  ::-moz-placeholder {color: ${({ theme }) => theme.colors.textColor};} 
  :-ms-input-placeholder {color: ${({ theme }) => theme.colors.textColor};} 
  ::placeholder {color: ${({ theme }) => theme.colors.textColor};} 

  &:focus::-webkit-input-placeholder { opacity: 0; } 
  &:focus:-moz-placeholder { opacity: 0; } 
  &:focus::-moz-placeholder { opacity: 0; }
  &:focus:-ms-input-placeholder { opacity: 0; }
  &:focus::placeholder { opacity: 0}; 

  &:focus{
    background-color: ${({ theme }) => theme.colors.inputFocus};
  }
  
  @media screen and (max-width:768px){
    width: 10em;
    height: 1.5em;
  }

  @media screen and (max-width:380px){
    width: 9em;
    height: 1em;
  }

  :-webkit-autofill,
  :-webkit-autofill:hover, 
  :-webkit-autofill:focus, 
  :-webkit-autofill:active{
    -webkit-box-shadow: 0 0 0 30px ${({ theme }) => theme.colors.background} inset !important;
  }

  :-webkit-autofill{
    -webkit-text-fill-color: ${({ theme }) => theme.colors.textColor} !important;
  }
`

export const Form = styled.form`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  flex-direction: column;
  margin: 0 auto;

  position:absolute;
  transform: translate(-50%, -50%);
  top: 35%;
  left: 50%;
  z-index: 1;
  width: 450px;
  background: ${({ theme }) => theme.colors.background};
  border-style: solid;
  border-radius: .2em;
  border-width: .1em;
  border-color: ${({ theme }) => theme.colors.secondary};
  filter: drop-shadow(.2em .2em .5em black);

  @media screen and (max-width:768px){
    width: 300px;
  }

  @media screen and (max-width:380px){
    top: 50%;
    //width: 200px;
  }
`

export const QRContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 200px;
  height: 200px;
  padding: 15px;
  background: white;
  margin: .75em  .75em .75em .75em;
  border-radius: 5px;
`

export const Alert = styled.form`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  flex-direction: column;
  margin: 0 auto;
  top: 40%;
  left: 50%;
  position:fixed;
  transform: translate(-50%, -50%);
  z-index: 1000;
  width: 450px;
  background: ${({ theme }) => theme.colors.background};
  border-style: solid;
  border-radius: 7px;
  //border-width: 10pt;
  border-color: ${({ theme }) => theme.colors.secondary};
  filter: drop-shadow(6px 6px 8px black);

  @media screen and (max-width:768px){
    width: 300px;
  }

  @media screen and (max-width:380px){
    width: 200px;
  }
`
export const CheckmarkCheck = styled.path`
  border-color: black;
  transform-origin: 50% 50%;
  stroke-dasharray: 48;
  stroke-dashoffset: 48;
  animation: stroke 0.3s cubic-bezier(0.65, 0, 0.45, 1) 0.8s forwards;

  @keyframes stroke {
    100% {
      stroke-dashoffset: 0;
    }
  }
  @keyframes scale {
  0%, 100% {
    transform: none;
  }
  50% {
    transform: scale3d(1.1, 1.1, 1);
  }
  }
  @keyframes fill {
  100% {
    box-shadow: inset 0px 0px 0px 30px #00FF7F ;
  }
}
`
export const Checkmark = styled.svg`
  width: 56px;
  height: 56px;
  border-radius: 50%;
  display: block;
  stroke-width: 2;
  stroke: #000000;
  stroke-miterlimit: 10;
  margin: 10% auto;
  box-shadow: inset 0px 0px 0px #00FF7F;
  animation: fill .4s ease-in-out .4s forwards, scale .3s ease-in-out .9s both;
`

export const HelpText = styled.span`
  color:${({ theme }) => theme.colors.secondary};
  text-decoration: underline;
  cursor: pointer;
`

export const Link = styled.a`
  color: ${({ theme }) => theme.colors.secondary};

  &.visited{
    color: ${({ theme }) => theme.colors.secondary};
  }
`

export const QRText = styled.div`
  margin-top: .15em;
  font-size: 1.5em;
  color: ${({ theme }) => theme.colors.textColor};
  text-align: left;
  padding: .35em;

  &.marginBottom{
    margin-bottom: .15em;
  }

  @media screen and (max-width:768px){
    font-size: 1.25em;
  }

  @media screen and (max-width:380px){
    font-size: 1em;
  }  
`